import { Component, Input, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { Transaction } from 'src/app/shared/models/transaction/transaction';
import { TransactionType } from 'src/app/shared/models/transaction/transaction-type';

@Component({
  selector: 'app-transaction-card-expanded',
  templateUrl: './transaction-card-expanded.component.html',
  styleUrls: ['./transaction-card-expanded.component.scss'],
})
/**
 * Expanded transaction card
 */
export class TransactionCardExpandedComponent implements OnInit {
  displayedColumns: string[] = [
    'code',
    'serial',
    'points',
    'addedby',
    'expiresOn',
    'note',
  ];
  transactionExpandedLabels = {
    code: 'code',
    codes: 'codes',
    printerSerial: 'printer-serial',
    points: 'points',
    totalPoints: 'total-points',
    onLabel: 'on',
    expiredLabel: 'expired-on',
    transactionError: 'transaction-error',
    portPrinters: 'port-printers',
    expiresOn: 'expires-on',
    expiration: 'expiration',
    addedBy: 'added-by',
    notes: 'notes',
    labelBy: 'label-by',
  };
  transactionTypes = TransactionType;
  dateFormat?: string;
  language = '';
  showNotes: boolean = false;
  note = '';

  activeElement: any = null;

  @Input() transactions!: Transaction[];
  @Input() sum!: number;
  @Input() loadingTransaction!: boolean;
  @Input() codesLabel!: string;

  /**
   * Constructor
   */
  constructor(private translationService: TranslationService) {}

  /**
   * Initator
   */
  ngOnInit() {
    this.translationService.translateObject(this.transactionExpandedLabels);
    this.language = this.translationService.getActiveLang();
    this.dateFormat = this.getDateFormatForLocale(this.language);
  }

  /**
   * Return format date using dots instead of slash based on language
   * @param {string} locale
   * @return {string}
   */
  private getDateFormatForLocale(locale: string): string {
    return locale === 'en' ? 'MM.dd.yyyy' : 'dd.MM.yyyy';
  }

  /**
   * Toggles show comment
   * @param {any} element
   */
  toggleNotes(element: any) {
    if (this.showNotes && this.activeElement === element) {
      this.closeNotes();
    } else {
      this.showNotes = true;
      this.activeElement = element;
      this.note = element.note?.trim();
    }
  }

  /**
   * Turns off show comment
   */
  closeNotes() {
    this.showNotes = false;
    this.activeElement = null;
    this.note = '';
  }
}
